<template>
    <div class="k-article"  v-if="totalPages != 1">
        <div class="article-page">
            <ul class="page-list">
                <li v-if="currentPage != 1 && totalPages !=0" class="change-btn">
                    <a href="javascript:;" @click="toPre">上一页</a>
                </li>
                <li v-for="(page,index) in pages" :key="index" :class="{'cur': currentPage == page, 'has-border': page > 0}" @click="toPage(page)">
                    <a v-if="page">{{page}}</a>
                    <span v-else href="javascript:;">...</span>
                </li>
                <li v-if="currentPage != totalPages  && totalPages !=0  " class="change-btn">
                    <a href="javascript:;" @click="toNext">下一页</a>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
    export default {
        name:'Paging',
        props: {
            totalPages: { //总页数
                type:Number,
                default:0
            },
        },
        data(){
            return{
                currentPage: 1,   //当前页数
            }
        },
        computed: {
            // 分页用省略号表示
            pages () {
                let c = this.currentPage;
                let t = this.totalPages; //10
				let arr = []
				if (t === 1) {
					return arr
				}
				if (t <= 10) {
					for (let i = 1; i <= t; i++) {
                        arr.push(i)
                    }
					return arr
				}
				if (c <= 6) return [1, 2, 3, 4, 5, 6, 7, 0, t]
				if (c >= t - 1) return [1, 0, t-6, t-5, t-4, t-3, t-2, t-1, t]
				return [1, 0, c-4, c-3, c-2, c-1, c, c+1, c+2]
			}
        },
        methods: {
            // 切换页数
            toPage (page) {
                this.currentPage = page;
                this.$emit('reqData',this.currentPage)
                // this.toTop()
                this.countAd(4520)
			},
            //上一页
            toPre() {
                this.countAd(4520)
                if(this.currentPage > 1) {
                    this.currentPage--
                    this.$emit('reqData',this.currentPage)
                }
            //    this.toTop()
            },
            //下一页
            toNext() {
                this.countAd(4520)
                if(this.currentPage < this.totalPages) {
                    this.currentPage++
                    this.$emit('reqData',this.currentPage)
                }
            //    this.toTop()
            },
           //重置当前页面的当前页数
           restCurrentPage() {
               this.currentPage = 1
           },
            //滚动到顶部
            toTop() {
                // let scrollTop = document.body.scrollTop || document.documentElement.scrollTop
                // const timeToTop = setInterval( () => {
                //   document.body.scrollTop = document.documentElement.scrollTop = scrollTop -= 40;
                //   if(scrollTop <= 0) {
                //      clearInterval(timeToTop)
                //   }
                // },20)
                // document.body.scrollTop = document.documentElement.scrollTop = 0
            }
        },
    }
</script>

<style lang="scss">
    .k-article{
        .article-page{
            .page-list{
                padding: 25px 0 20px;
                // text-align: center;
                display: flex;
                // justify-content: center;
                align-content: center;
                flex-wrap:wrap;
                .change-btn {
                    border: 1px solid #ccc;
                    padding: 0 13px;
                    &:hover {
                        border: 1px solid #ff9900;
                    }
                }
            }
            li{
                margin: 0 2px;
                font-size: 14px;
                line-height: 30px;
                cursor: pointer;
                a{
                    color: #000;
                    display: block;
                }
                &:hover{
                    a{
                        color: #ff9900;
                    }
                }
                &.has-border {
                    border: 1px solid #cccccc;
                    // padding: 0 13px;
                    width: 36px;
                    text-align: center;
                    &:hover {
                        border: 1px solid #ff9900;
                    }
                }
                &.cur{
                    pointer-events: none;
                    background: #ff9900;
                    border: 1px solid #ff9900;
                    a{
                        color: #fff;
                    }
                }
            }
        }
    }
</style>